/**
 * provide abbr to a number. e.g. 1500 -> 1.5k
 * @param value the number
 * @param float digit count, default set to 0
 */
export const numberRound = (value: number, float = 0) => {
  if (value == null) return value;
  let unit = '';
  if (value >= 1000) {
    unit = 'k';
    value /= 1000;
  }
  if (value >= 1000) {
    unit = 'm';
    value /= 1000;
  }

  return `${value.toFixed(float)}${unit}`;
};

export const max = (nList: number[]) =>
  nList.reduce((acc, cur) => Math.max(acc, cur));

export const numberToUpper = (val: number) => {
  const baseUpper = [
    '零',
    '一',
    '二',
    '三',
    '四',
    '五',
    '六',
    '七',
    '八',
    '九',
    '十',
  ];
  const enterDigits = ['十', '百', '千', '万'];
  if (val <= 10) {
    return baseUpper[val];
  }
  if (val > 99999) {
    return val;
  }
  const strVal = val.toString();
  const valLength = strVal.length;
  let result = '';
  for (let i = 0; i < valLength; i++) {
    const num = Number(strVal[i]);
    result += `${valLength === 2 && num === 1 ? '' : baseUpper[num]}${valLength - i > 1 && num > 0 ? enterDigits[valLength - 2 - i] : ''}`;
  }
  for (let i = result.length - 1; i >= 0; i--) {
    if (result[i] === '零' && result[i - 1] === '零') {
      result = result.slice(0, i - 1) + result.slice(i);
    }
  }
  if (result[result.length - 1] === '零') {
    result = result.slice(0, result.length - 1);
  }
  return result;
};

export const generateUniqueNumber = (
  existingNumbers: number[],
  min: number,
  max: number,
) => {
  let num;
  do {
    num = Math.floor(Math.random() * (max - min + 1)) + min;
  } while (existingNumbers.includes(num));

  return num;
};
